export const utilizationDateFilterKey = 'utilization_date_filter';
export const utilizationRefreshStateKey = 'utilization_refresh_state';
export const usageDateFilterKey = 'usage_date_filter';
export const usageRefreshStateKey = 'usage_refresh_state';
export const utilizationFullGraphKey = 'full_graph';
// The volume-filter param, defined once in `~/shared/utils/filterUrlParams` and re-exported
// here so existing `apiFilterKey` importers keep working.
export { apiFiltersParamKey as apiFilterKey } from '~/shared/utils/filterUrlParams';
export const volumeAccountIdKey = 'accountId';
